export default "__VITE_ASSET__BLvNqyPU__"